/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConvo.defs.js'
export * as $defs from './getConvo.defs.js'
